import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from '@nuxtjs/composition-api';
import type { DefineComponent } from 'vue';

interface Props {
    reverse?: boolean,
    direction?: 'row' | 'column',
    button1LeftIcon?: string,
    button1RightIcon?: string,
    button1Type?: 'tonal' | 'cta' | 'outline' | 'text',
    button1Styling?: 'primary' | 'secondary' | 'tertiary' | 'quaternary',
    button1Size?: 'l' | 'm' | 's' | 'xs',
    button1Text: string,
    button1Tag?: string | DefineComponent,
    button1Props?: Record<string, unknown>,
    button2LeftIcon?: string,
    button2RightIcon?: string,
    button2Type?: 'tonal' | 'cta' | 'outline' | 'text',
    button2Styling?: 'primary' | 'secondary' | 'tertiary' | 'quaternary',
    button2Size?: 'l' | 'm' | 's' | 'xs',
    button2Text: string,
    button2Tag?: string | DefineComponent,
    button2Props?: Record<string, unknown>,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DecisionButtons',
  props: {
    reverse: { type: Boolean, default: false },
    direction: { default: 'row' },
    button1LeftIcon: null,
    button1RightIcon: null,
    button1Type: { default: 'tonal' },
    button1Styling: { default: 'tertiary' },
    button1Size: null,
    button1Text: null,
    button1Tag: null,
    button1Props: null,
    button2LeftIcon: null,
    button2RightIcon: null,
    button2Type: { default: 'cta' },
    button2Styling: { default: 'primary' },
    button2Size: null,
    button2Text: null,
    button2Tag: null,
    button2Props: null
  },
  emits: ['click-1', 'click-2'],
  setup(__props: any) {

const props = __props as { reverse: boolean, direction: 'row' | 'column', button1LeftIcon?: string, button1RightIcon?: string, button1Type: 'tonal' | 'cta' | 'outline' | 'text', button1Styling: 'primary' | 'secondary' | 'tertiary' | 'quaternary', button1Size?: 'l' | 'm' | 's' | 'xs', button1Text: string, button1Tag?: string | DefineComponent, button1Props?: Record<string, unknown>, button2LeftIcon?: string, button2RightIcon?: string, button2Type: 'tonal' | 'cta' | 'outline' | 'text', button2Styling: 'primary' | 'secondary' | 'tertiary' | 'quaternary', button2Size?: 'l' | 'm' | 's' | 'xs', button2Text: string, button2Tag?: string | DefineComponent, button2Props?: Record<string, unknown> };





const {
    reverse,
    button1LeftIcon,
    button1RightIcon,
    button1Type,
    button1Styling,
    button1Size,
    button1Text,
    button1Tag,
    button1Props,
    button2LeftIcon,
    button2RightIcon,
    button2Type,
    button2Styling,
    button2Size,
    button2Text,
    button2Tag,
    button2Props,
    direction,
} = toRefs(props);


return { __sfc: true,props, reverse, button1LeftIcon, button1RightIcon, button1Type, button1Styling, button1Size, button1Text, button1Tag, button1Props, button2LeftIcon, button2RightIcon, button2Type, button2Styling, button2Size, button2Text, button2Tag, button2Props, direction }
}

})